<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import {
  apiRushToken
} from './plugins/apis'
export default {
  data() {
    return {
    };
  },
  components: {
  },
  mounted() {
      setInterval(async ()=>{
        if(window.localStorage.app_token){
          // await this.rushToken()
        }
      },5000*1000)
  },
  methods: {
      async rushToken(){
        let res = await apiRushToken()
        if(res.code === 200){
          window.localStorage.setItem('app_token',res.data.token)
        }
      }
  }
};
</script> 